interface TagInputProps {
  value: string[];
  onChange: (tags: string[]) => void;
  placeholder?: string;
  className?: string;
}

export function TagInput({
  value,
  onChange,
  placeholder = 'tag1, tag2, ...',
  className,
}: TagInputProps) {
  return (
    <input
      type="text"
      value={value.join(', ')}
      onChange={e => onChange(e.target.value.split(',').map(t => t.trim()).filter(Boolean))}
      className={className || `w-full text-sm bg-surface-muted border border-line rounded-lg px-3 py-2
        focus:outline-none focus:ring-1 focus:ring-coral-500/20`}
      placeholder={placeholder}
    />
  );
}
